/**
 * Ryan O'Dowd
 * 2018-02-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  return {
    centerComponentWrapper: {
      // @TODO: flex: 1,
      flexShrink: 1,
      flexDirection: 'row',
      justifyContent: Platform.OS === 'ios' ? 'center' : 'flex-start',
    },
    centerComponentInner: {
      display: 'flex',
      flexShrink: 1,
      flexDirection: 'row',
    },
    betaTitleText: {
      width: 'auto',
    },
    betaSuperscript: {
      display: 'flex',
      flexShrink: 1,
      color: colors.accent,
      fontSize: globalScale * 10,
      fontFamily: fonts.primaryBold,
    },
    settingsListContainer: { // @TODO: combine with SectionList (pass prop to say flat or section?)
      gap: 4,
      paddingBottom: safeAreaInsets.bottom + 4,
    },
    buttonGroupWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginTop: globalScale * 8,
      padding: globalScale * 4,
      fontSize: globalScale * 14,
      // @TODO: marginBottom: 0, // @TODO: not working?

      width: '100%',
    },
    currentTranslationWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-end',
      color: colors.white,
    },
    currentTranslation: {
      marginTop: globalScale * 8,
      color: colors.accent,
      fontFamily: fonts.primaryBold,
      fontSize: globalScale * 18,
      borderWidth: globalScale * 2,
      borderColor: colors.accent,
      borderRadius: globalScale * 12,
      padding: globalScale * 8,
    },
  };
};

export default getStyles;
